
import { Component, Prop, Vue } from "vue-property-decorator";
import "./social-icons.scss";

@Component
export default class extends Vue {
  @Prop(String) readonly url!: string;
  @Prop(String) readonly id!: string;
}
